/*! OnlyPlanks — client-side price fill for UNLOCKED map-hide PDPs (30 Sep 2026, price-leak close)
 *  Server-rendered HTML for map-hide products contains NO numeric prices any more.
 *  Once the visitor has passed the email unlock (cookie/localStorage op_map_unlock=1 => body.op-map-unlocked),
 *  this reads the variant price from the storefront's own /products/<handle>.js and fills the empty
 *  placeholders ([data-op-fill]) + the calculator data attributes. Locked visitors: does nothing.
 *  Checkout pricing is untouched (Shopify variant price is still the source of truth).
 */
(function () {
  'use strict';
  var body = document.body;
  if (!body || !body.classList.contains('op-map-hide')) return;

  function unlocked() {
    try {
      if (body.classList.contains('op-map-unlocked')) return true;
      if (document.cookie && /(^|;\s*)op_map_unlock=1(;|$)/.test(document.cookie)) return true;
      if (window.localStorage && localStorage.getItem('op_map_unlock') === '1') return true;
    } catch (e) {}
    return false;
  }

  function handle() {
    var m = (location.pathname || '').replace(/\/+$/, '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function money(n) {
    try {
      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(n);
    } catch (e) {
      return '$' + Number(n).toFixed(2);
    }
  }

  var product = null;
  var loading = null;
  var applying = false;

  function load() {
    if (product) return Promise.resolve(product);
    if (loading) return loading;
    var h = handle();
    if (!h) return Promise.resolve(null);
    loading = fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { product = j; return j; })
      .catch(function () { return null; });
    return loading;
  }

  function selectedVariantId() {
    var inp = document.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
    if (inp && inp.value) return String(inp.value);
    var q = new URLSearchParams(location.search).get('variant');
    return q ? String(q) : '';
  }

  function pickVariant(p) {
    if (!p || !p.variants || !p.variants.length) return null;
    var id = selectedVariantId();
    for (var i = 0; i < p.variants.length; i++) {
      if (String(p.variants[i].id) === id) return p.variants[i];
    }
    return p.variants[0];
  }

  function apply() {
    if (applying || !unlocked()) return;
    applying = true;
    load().then(function (p) {
      var v = pickVariant(p);
      applying = false;
      if (!v) return;
      var box = v.price / 100;
      // main product only: never touch listing/recommendation cards (product-card) or other products
      function mine(list) {
        var out = [];
        for (var j = 0; j < list.length; j++) if (!list[j].closest('product-card, .resource-card, .product-recommendations')) out.push(list[j]);
        return out;
      }
      var cards = mine(document.querySelectorAll('.op-box-sell--buy, .op-price-dual'));
      var boxM2 = 0;
      var buyCard = document.querySelector('.op-box-sell--buy');
      if (buyCard) boxM2 = parseFloat(buyCard.getAttribute('data-box-m2')) || 0;
      for (var i = 0; !boxM2 && i < cards.length; i++) {
        var bm = parseFloat(cards[i].getAttribute('data-box-m2') || cards[i].getAttribute('data-op-box-m2'));
        if (bm > 0) { boxM2 = bm; break; }
      }
      var m2 = boxM2 > 0 ? Math.round((box / boxM2) * 100) / 100 : null;
      var changed = false;
      var fills = mine(document.querySelectorAll('[data-op-fill]'));
      for (var f = 0; f < fills.length; f++) {
        var kind = fills[f].getAttribute('data-op-fill');
        var txt = kind === 'box' ? money(box) : (m2 != null ? money(m2) : '');
        if (fills[f].textContent !== txt) { fills[f].textContent = txt; changed = true; }
      }
      var attrTargets = cards;
      for (var a = 0; a < attrTargets.length; a++) {
        var el = attrTargets[a];
        var isBuy = el.classList.contains('op-box-sell--buy');
        var kBox = isBuy ? 'data-price-per-box' : 'data-op-price-per-box';
        var kM2 = isBuy ? 'data-price-per-m2' : 'data-op-price-per-m2';
        if (el.getAttribute(kBox) !== String(box)) { el.setAttribute(kBox, String(box)); changed = true; }
        if (m2 != null && el.getAttribute(kM2) !== String(m2)) { el.setAttribute(kM2, String(m2)); changed = true; }
      }
      if (m2 != null) {
        if (window.OP_MAP_PPM2 !== m2) changed = true;
        window.OP_MAP_PPM2 = m2;
        body.setAttribute('data-op-map-ppm2', String(m2));
      }
      // let the box calculator refresh its total - ONLY if we actually changed something
      // (1 Oct 2026 freeze fix: unconditional dispatch + MutationObserver = endless loop once a m2 value was typed)
      if (!changed) return;
      var inputs = document.querySelectorAll('.op-box-m2-input');
      for (var k = 0; k < inputs.length; k++) {
        if (inputs[k].value) inputs[k].dispatchEvent(new Event('input', { bubbles: true }));
      }
    });
  }

  function start() {
    if (!unlocked()) return;
    apply();
    // Horizon swaps the price block on variant change / section re-render: refill when placeholders reappear empty.
    var moTimer = null;
    function ownEmpty() {
      var list = document.querySelectorAll('[data-op-fill]:empty');
      for (var i = 0; i < list.length; i++) {
        if (!list[i].closest('product-card, .resource-card, .product-recommendations')) return true;
      }
      return false;
    }
    var mo = new MutationObserver(function () {
      if (moTimer) return;
      moTimer = setTimeout(function () {
        moTimer = null;
        if (ownEmpty()) apply();
      }, 150);
    });
    mo.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') apply();
    });
    document.addEventListener('variant:update', apply);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  // unlock happens via page reload (onlyplanks-map-unlock.js), so no live unlock listener needed
})();
